import { useCallback } from "react";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";
import { useLoadingScreen } from "@/components/features/side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";

import { convertToViewModelToInput } from "./composition/convert-view-model-to-input";
import { OptionStockUpdate_StockManagementPage_Mutation } from "./mutation";

import type { OptionStockDiffStore } from "../../../usecase/use-create-form-model/option-stock-diff-store";
import type { ServerModel } from "../../../usecase/use-create-form-model/type";

type Props = {
	serverModel: ServerModel;
	optionStockDiffStore: OptionStockDiffStore;

	onReInitialize: () => void;
};

export const useUpdateOptionStock = ({ serverModel, optionStockDiffStore, onReInitialize }: Props) => {
	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();

	const { mutationFunc } = useCustomMutation(OptionStockUpdate_StockManagementPage_Mutation);

	const onUpdateOptionStock = useCallback(async () => {
		showLoadingScreenCallback();

		const input = convertToViewModelToInput({ serverModel, optionStockDiffStore });

		const { errors } = await mutationFunc({
			variables: {
				input,
			},
		}).finally(() => {
			hideLoadingScreenCallback();
		});

		if (!errors) {
			notifyUserEventInfo({
				title: "オプション在庫を更新しました",
			});

			onReInitialize();
		}
	}, [
		hideLoadingScreenCallback,
		mutationFunc,
		onReInitialize,
		optionStockDiffStore,
		serverModel,
		showLoadingScreenCallback,
	]);

	return {
		onUpdateOptionStock,
	};
};
